function runAfterDOMReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
}

runAfterDOMReady(() => {

  // $('.product-form__input input[type="radio"]+label').slice(0, 3).css('display', 'inline-block');
  // $(".moreless-button").click(function(e){
  //   e.preventDefault();
  //   $('.product-form__input input[type="radio"]+label:hidden').slice(0,3).css('display', 'inline-block');
    
  //   if($('.product-form__input input[type="radio"]+label:hidden').length == 0){
  //      $(".moreless-button").fadeOut("slow");
  //     }
  // });

  // Auto-select variant based on URL parameter
  let variantSelectionComplete = false;
  
  function selectVariantFromURL() {
    // Prevent multiple executions
    if (variantSelectionComplete) {
      console.log('Variant selection already completed');
      return;
    }
    
    // Get variant ID from URL
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    console.log('URL variant ID:', variantId); // Debug log
    
    if (!variantId) return;
    
    // Get the variant-radios element - use the ID or class selector
    const variantRadios = document.querySelector('variant-radios') || document.querySelector('#variant-radios-{{ section.id }}');
    if (!variantRadios) {
      console.log('variant-radios element not found'); // Debug log
      return;
    }
    
    // Parse the variant data
    const variantDataScript = variantRadios.querySelector('script[type="application/json"]');
    if (!variantDataScript) {
      console.log('Variant data script not found'); // Debug log
      return;
    }
    
    const variants = JSON.parse(variantDataScript.textContent);
    console.log('Available variants:', variants); // Debug log
    
    // Find the variant with matching ID
    const selectedVariant = variants.find(v => v.id === parseInt(variantId));
    if (!selectedVariant) {
      console.log('Selected variant not found for ID:', variantId); // Debug log
      return;
    }
    
    console.log('Found variant:', selectedVariant); // Debug log
    
    // Get product options to understand which option is which
    const productOptions = window.product_options;
    console.log('Product options:', productOptions); // Debug log
    
    // Process each option value with its corresponding option name
    selectedVariant.options.forEach((optionValue, index) => {
      const optionName = productOptions[index];
      console.log(`Processing ${optionName}: ${optionValue}`); // Debug log
      
      // Find the correct container based on option name
      let targetRadio = null;
      
      if (optionName && (optionName.toLowerCase() === 'color' || optionName.toLowerCase() === 'colour')) {
        // Look for color in the swatches container
        const colorSwatches = variantRadios.querySelector('.swatches-container');
        if (colorSwatches) {
          targetRadio = Array.from(colorSwatches.querySelectorAll('input[type="radio"]')).find(
            radio => radio.value === optionValue
          );
        }
      } else {
        // Look for other options (like Size) in other-opt-container
        const otherContainers = variantRadios.querySelectorAll('.other-opt-container');
        console.log(`Found ${otherContainers.length} other-opt-containers`); // Debug log
        
        for (const container of otherContainers) {
          const radios = container.querySelectorAll('input[type="radio"]');
          console.log(`Radio values in container:`, Array.from(radios).map(r => r.value)); // Debug log
          
          targetRadio = Array.from(radios).find(
            radio => radio.value === optionValue
          );
          if (targetRadio) break;
        }
      }
      
      console.log(`Target radio for "${optionValue}":`, targetRadio); // Debug log
      
      if (targetRadio && !targetRadio.checked) {
        targetRadio.checked = true;
        console.log(`Checked radio for ${optionName}: ${optionValue}`); // Debug log
        
        // Update UI for size selection (mobile view)
        const otherOptContainer = targetRadio.closest('.other-opt-container');
        if (otherOptContainer) {
          const selectedHolder = otherOptContainer.querySelector('.selected-size-holder');
          if (selectedHolder) {
            selectedHolder.textContent = optionValue;
            console.log('Updated selected-size-holder:', optionValue); // Debug log
          }
        }
      } else if (!targetRadio) {
        console.log(`Radio not found for ${optionName}: ${optionValue}`);
      }
    });
    
    // Trigger change event to update variant selection
    // Use a small delay to ensure DOM updates are complete
    setTimeout(() => {
      // Temporarily disable URL updates to prevent any reload issues
      const originalUpdateUrl = variantRadios.dataset.updateUrl;
      variantRadios.dataset.updateUrl = 'false';
      
      // Trigger change event on the variant-radios element
      const changeEvent = new Event('change', { bubbles: true });
      variantRadios.dispatchEvent(changeEvent);
      
      // Also call the onVariantChange method if it exists
      if (variantRadios.onVariantChange && typeof variantRadios.onVariantChange === 'function') {
        console.log('Calling onVariantChange method');
        variantRadios.onVariantChange();
      }
      
      // Restore original URL update setting after a delay
      setTimeout(() => {
        if (originalUpdateUrl !== 'false') {
          delete variantRadios.dataset.updateUrl;
        }
      }, 200);
      
      // Mark selection as complete
      variantSelectionComplete = true;
      
      // Log for debugging (can be removed in production)
      console.log('Variant auto-selected:', selectedVariant.id, selectedVariant.options);
      
      // Check if add to cart button is enabled
      const addButton = document.querySelector('button[name="add"]');
      console.log('Add to cart button enabled:', addButton && !addButton.hasAttribute('disabled'));
    }, 100);
  }
  
  // Call the function on page load with retry mechanism
  let retryCount = 0;
  const maxRetries = 20; // Maximum 1 second of retries (20 * 50ms)
  
  function initializeVariantSelection() {
    // Wait for custom element to be defined
    if (!customElements.get('variant-radios')) {
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(initializeVariantSelection, 50);
      }
      return;
    }
    
    const variantRadios = document.querySelector('variant-radios') || document.querySelector('#variant-radios-{{ section.id }}');
    
    if (variantRadios) {
      // Give the element time to initialize
      setTimeout(() => {
        selectVariantFromURL();
      }, 100);
    } else if (retryCount < maxRetries) {
      // Retry after a short delay if variant-radios element is not ready
      retryCount++;
      setTimeout(initializeVariantSelection, 50);
    } else {
      console.log('Max retries reached - variant-radios element not found');
    }
  }
  
  // Initialize variant selection
  initializeVariantSelection();
  
  // Also try on window load as a fallback (only if not already done)
  window.addEventListener('load', function() {
    if (!variantSelectionComplete) {
      // Check if variant hasn't been selected yet
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      
      if (variantId) {
        console.log('Attempting variant selection on window load');
        selectVariantFromURL();
      }
    }
  });

  if(window.innerWidth < 750){
    
      // Get all selected-size-box elements within the specified path
      const sizeBoxes = document.querySelectorAll('.other-opt-container .product-form__input .selected-size-box');

      // Add click event listener to each size box
      sizeBoxes?.forEach(sizeBox => {
        sizeBox.addEventListener('click', function() {
          // Get all dropdown elements
          const dropdowns = document.querySelectorAll('.other-opt-container .product-form__input .opt-dropdown');
          
          // Toggle 'active' class on each dropdown
          dropdowns?.forEach(dropdown => {
            if (dropdown.classList.contains('active')) {
              dropdown.classList.remove('active');
            } else {
              dropdown.classList.add('active');
            }
          });
        });
      });
    
      // append list value in selectbox
    // Get all label elements within the dropdown
    const dropdownLabels = document.querySelectorAll('.other-opt-container .product-form__input .opt-dropdown li label');

    // Add click event listener to each label
    dropdownLabels?.forEach(label => {
      label.addEventListener('click', function() {
        // Get all selected-size-holder elements
        const sizeHolders = document.querySelectorAll('.other-opt-container .selected-size-box .selected-size-holder');
        
        // Get the sibling element's value (assuming it's an input)
        const siblingInput = this?.parentElement?.querySelector('input');
        
        // Process each size holder
        sizeHolders?.forEach(holder => {
          // Clear the content
          if(holder){
            holder.innerHTML = '';
          }
          
          
          // Append the sibling's value if it exists
          if (siblingInput && siblingInput.value) {
            holder.textContent = siblingInput?.value;
          }
        });
      });
    });
    
    // Auto-select variant based on URL on mobile
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      // Find the selected label and trigger click
      setTimeout(() => {
        const checkedInput = document.querySelector('.other-opt-container .product-form__input .opt-dropdown input[type="radio"]:checked');
        if (checkedInput) {
          const label = checkedInput.nextElementSibling;
          if (label) {
            label.click();
          }
        }
      }, 500);
    }
    
    // When click outside selectbox close
      // Add click event listener to the document
    document.addEventListener('click', function(event) {
      // Check if the clicked element is NOT inside the selected-size-box
      if (!event.target.closest('.other-opt-container .product-form__input .selected-size-box')) {
        // Get all dropdown elements
        const dropdowns = document.querySelectorAll('.other-opt-container .product-form__input .opt-dropdown');
        
        // Remove 'active' class from each dropdown
        dropdowns?.forEach(dropdown => {
          dropdown.classList.remove('active');
        });
      }
    });
  }
  
}); // End of runAfterDOMReady